import { useEffect } from 'react';
import LandingFooter from './LandingFooter';
import LandingHeader from './LandingHeader';
import ScrollTop from './ScrollTop';
import VideoPopup from '../components/VideoPopup';
import { preventEmptyAnchor } from '../utils/dom';

const LandingLayout = ({ children, isAuthenticated, onLogin, onLogout, onRegister, onDashboard }) => {
    useEffect(() => {
        preventEmptyAnchor();
    }, []);

    return (
        <div id="page" className="page">
            <LandingHeader
                isAuthenticated={isAuthenticated}
                onLogin={onLogin}
                onLogout={onLogout}
                onRegister={onRegister}
                onDashboard={onDashboard}
            />
            {children}
            <LandingFooter />
            <ScrollTop />
            <VideoPopup />
        </div>
    );
};

export default LandingLayout;
